module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_2_1_row_1.ffe0c792.png";